import { useAuth } from '@/hooks/useAuth';
import { useLocation, Navigate } from 'react-router-dom';
import PageLoader from '@/components/ui/PageLoader';

export const AdminRoute = ({ children }: { children: React.ReactNode }) => {
  const { user, isAdmin, isLoading, rolesLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <PageLoader />;
  }

  if (!user) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }

  // Wait for roles before deciding admin gating, otherwise a fresh login
  // would briefly see isAdmin=false and bounce to "/".
  if (rolesLoading) {
    return <PageLoader />;
  }

  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};
